import { render, staticRenderFns } from "./SearchSettings.vue?vue&type=template&id=0a4883e3&scoped=true&"
import script from "./SearchSettings.vue?vue&type=script&lang=js&"
export * from "./SearchSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4883e3",
  null
  
)

export default component.exports